import * as moment from 'moment';
import { TemplateService } from '../../services/template.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { ApiService } from '../../services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { HttpParams } from '@angular/common/http';
var HistoryLogComponent = (function () {
    function HistoryLogComponent(modalService, apiService, template, translate) {
        this.modalService = modalService;
        this.apiService = apiService;
        this.template = template;
        this.translate = translate;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.loading = false;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.errors = [];
        this.selectedCustomercode = null;
        this.checkdate = null;
        this.defaultLabel = null;
        this.sortBy = null;
        this.sortMode = null;
        this.no_data = true;
        this.errorMsg = '';
        this.allDeliverycodeSelected = [];
        this.allDocumentType = [];
        this.allDeliverycode = true;
        this.allDocType = true;
        this.selectedValues = [];
        this.roles = [];
        this.list = [];
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
    }
    HistoryLogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getHistoryLogType();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadGroups();
            _this.userData();
            _this.loadTexts();
        });
        this.loadGroups();
        this.userData();
        this.loadTexts();
        this.searchRole = null;
        this.searchUsername = null;
    };
    Object.defineProperty(HistoryLogComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    HistoryLogComponent.prototype.getHistoryLogType = function () {
        var _this = this;
        this.apiService.getHistoryLogType().subscribe(function (data) {
            _this.historyLogType = data.results;
        });
    };
    HistoryLogComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    HistoryLogComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    Object.defineProperty(HistoryLogComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    HistoryLogComponent.prototype.loadTexts = function () {
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
    };
    HistoryLogComponent.prototype.sentdate = function () {
        this.checkdate = 1;
    };
    HistoryLogComponent.prototype.optionChanged = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.searchData();
    };
    HistoryLogComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    HistoryLogComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var data = {
            page: this.currentPage,
            page_size: this.itemsPerPage,
            user: this.searchUsername,
            role: this.searchRole,
            log_type: this.selectedAction || '',
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD')
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        if (this.currentPage === 1) {
            params = null;
        }
        // TODO wait api history-log
        this.apiService.getHistoryLog(data).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    HistoryLogComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
            errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
        // let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
        // if (dayDiff > 60 && this.authService.isAccountant()) {
        //   this.errorMsg = "ไม่สามารถเลือกระยะเวลาเกิน 60 วัน";
        // }
    };
    HistoryLogComponent.prototype.clearData = function () {
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
        this.selectedCustomercode = null;
        this.selectedDeliverycode = null;
        this.selectedRdDocumentType = null;
        this.deliverycode = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allDeliverycode = true;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedValues = [];
        this.searchButtonClicked();
    };
    HistoryLogComponent.prototype.loadGroups = function () {
        var _this = this;
        this.roles = [{
                'label': this.translate.instant('COMMON.ALL'),
                'value': null
            }];
        this.apiService.getGroups().subscribe(function (roles) {
            _.forEach(roles, function (role) {
                _this.roles.push({
                    'label': role['name'],
                    'value': role['id']
                });
            });
            _this.roles = _.uniqBy(_this.roles, 'label');
        }, function (error) {
            console.log('error', error);
        });
    };
    HistoryLogComponent.prototype.userData = function () {
        var _this = this;
        this.list = [];
        this.list = [{
                'label': this.translate.instant('COMMON.ALL'),
                'value': null
            }];
        this.loading = true;
        this.apiService.getUsers().subscribe(function (res) {
            _.forEach(res.results, function (profile) {
                _this.list.push({
                    'label': profile.username,
                    'value': profile.id
                });
            });
            _this.loading = false;
            _this.list = _.uniqBy(_this.list, 'label');
        }, function (error) {
            _this.loading = false;
        });
    };
    HistoryLogComponent.prototype.clearSearch = function () {
        this.searchRole = null;
        this.searchUsername = null;
        this.search();
    };
    HistoryLogComponent.prototype.search = function () {
        this.currentPage = 1;
    };
    HistoryLogComponent.prototype.pageChanged = function () {
        var params = new HttpParams();
        params = params.append('page', this.currentPage.toString());
        this.searchData(params);
    };
    return HistoryLogComponent;
}());
export { HistoryLogComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.ts.pre-build-optimizer.js